import { useEffect, useState } from "react";

function diff(target) {
  let s = Math.floor((new Date(target) - new Date()) / 1000);
  if (s <= 0) return null;
  const d = Math.floor(s / 86400); s -= d * 86400;
  const h = Math.floor(s / 3600); s -= h * 3600;
  const m = Math.floor(s / 60); s -= m * 60;
  return { d, h, m, s };
}

export default function Countdown({ target }) {
  const [t, setT] = useState(() => diff(target));
  useEffect(() => {
    setT(diff(target));
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!t) {
    return (
      <div data-testid="countdown-done" className="font-display italic text-5xl md:text-7xl leading-tight">
        It happened!! <span className="block font-hand not-italic text-2xl md:text-3xl mt-4">Thank you for being part of our story.</span>
      </div>
    );
  }
  const cells = [[t.d, "Days"], [t.h, "Hours"], [t.m, "Minutes"], [t.s, "Seconds"]];
  return (
    <div data-testid="countdown" className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
      {cells.map(([v, l], i) => (
        <div key={l} className="bg-[#FFF9F0] border-2 border-[#252122] shadow-[6px_6px_0_#252122] px-4 py-6 md:py-8 text-center" style={{ transform: `rotate(${[-2, 1.5, -1, 2][i]}deg)` }}>
          <div className="font-display text-6xl md:text-8xl leading-none tabular-nums text-[#252122] overflow-hidden">
            <span key={v} className="tick">{String(v).padStart(2, "0")}</span>
          </div>
          <div className="kicker mt-3 text-[#A62D58]">{l}</div>
        </div>
      ))}
    </div>
  );
}
